define('controllers/myaccountpreferences',['require'],function(require) {
    return function() {
        //            var emailPreferencesGrid = CreateJohnGrid(),
        //                emailPreferencesColumns = [{ DataField: ""}];

        //            emailPreferencesGrid.init($("#tblEmailPreferences"), emailPreferencesColumns, "/EmailPreferencesAJAX.aspx");

        var msg = $("#msg");

        $("#btnOptOut, #btnOptIn").on("click", function () {
            var $this = $(this).prop('disabled', true),
                method = $this.prop('id');

            msg.hide();
            $.post("EmailPreferencesAJAX.aspx", { method: method }, function (response) {
                Utilities.handleAJAXResponse(response, function (obj) {
                    var successMsg = method == "btnOptIn" ? "You are now subscribed to our marketing emails!" : "You will no longer receive marketing emails from us.";
                    Utilities.setInfo(successMsg, msg);
                },
                function (error) {
                    Utilities.setError(error, msg);
                });
            }).complete(function () { $this.prop('disabled', false); });
        });
    };
});

